import React, {memo, useEffect, useState} from 'react';
import {Box, Paper} from "@mui/material";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/lab/Autocomplete";
import Button from "@mui/material/Button";
import Api from "../../utils/api";
import {toast} from "react-toastify";
import {Loading} from './../../components'
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Add from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import validator from 'validator';
import CurrencyFormat from "react-currency-format";

const ProductPins = memo((props) => {

    const {productID, onComplete} = props;

    const [loading, setLoading] = useState(true);
    const [form, setForm] = useState({});
    const [product, setProduct] = useState(null);

    useEffect(() => {
        handleRequest();
    }, []);

    const handleRequest = () => {
        new Api().get('/products/' + productID + '/types').then((response) => {
            if (typeof response != "undefined") {
                setForm(response.list);
                setProduct(response.product);
            }
            setLoading(false);
        }).catch((error) => {
            toast.error(error);
        });
    }



    const handleSubmit = (event) => {
        event.preventDefault();

        setLoading(true);

        new Api().post('/products/' + productID + '/types', { pins: form }, false).then((response) => {
            if (typeof response != "undefined") {
                if (response.status) {
                    toast.success(response.msg);
                    handleRequest();
                    if (typeof onComplete !== undefined) {
                        onComplete();
                    }
                } else {
                    toast.error(response.msg);
                }

                setLoading(false);
            }
        })

    };



    const handleDuplicateRaw = (event, i, key) => {
        let n_form = form;
        if (['price', 'discount', 'weight', 'per_count', 'tax', 'point' ,'maximum_order',"minimum_order"].includes(event.target.name)) {

            if (! validator.isNumeric(event.target.value)) {
                return false;
            }
        }
        n_form[i][event.target.name] = event.target.value;
        setForm([...n_form]);
    };

    const duplicateRaw = (index) => {
        let n_form = form;
        let price_parameters = [];
        product && product['price_parameters'] && product['price_parameters'].map((res, i) => {
            price_parameters.push({
                id: res.id,
                title: res.title,
                selected: '',
                children: res.children
            });
        });

        n_form.push({
            price: form?.[index]?.price || 0,
            discount: form?.[index]?.discount || 0,
            tax: form?.[index]?.tax || 0,
            weight: form?.[index]?.weight || 0,
            per_count: form?.[index]?.per_count || 0,
            point: form?.[index]?.point || 0,
            order_point: form?.[index]?.order_point || 0,
            title: form?.[index]?.title || "",
            maximum_order: form?.[index]?.maximum_order || 0,
            minimum_order: form?.[index]?.minimum_order || 0,
            count: 0,
            status: 1,
            id: '',
            price_parameters
        });

        setForm([...n_form]);
    }

    const deleteRaw = (index , id) => {

        new Api().delete('/products/' + 'types/' + id + "/delete")
            .then((response) => {
                let n_form = form;
                n_form.splice(index, 1)
                setForm([...n_form ]);
                setLoading(true);
                setLoading(false);
            }).catch((error) => {
                toast.error(error);
            });
    }


    const autoCompleteHandleSelect = (selected, i, key, index) =>
    {
        let n_form = form;

        if (selected) {

            n_form[i][key][index]['selected'] = selected;

            setForm([...n_form]);
        }

    };



    return(
        <form onSubmit={handleSubmit} className='animate__animated animate__fadeIn'>
            <Box mt={5}>
                <Paper style={{ padding: '25px'}}>
                    {form?.length > 0 && form.map((pin, index) => {
                        return (
                            <fieldset style={{ margin: '20px 0'}}>
                                <legend>تنوع محصول<span>&nbsp;#{index + 1}&nbsp;</span></legend>
                                <h4 style={{ textAlign: 'center' }}>موجودی کل<span>&nbsp;<CurrencyFormat value={pin.count} displayType={'text'} thousandSeparator={true} />&nbsp;</span>{product && product.package_type && product.package_type.title}</h4>
                                <table className='table-duplicate-row'>
                                    <tr>
                                        <td><b>عنوان</b></td>
                                        <td><TextField variant={'outlined'} margin={"dense"} fullWidth={true} size={"small"} onChange={(event) => handleDuplicateRaw(event, index)} name='title'  value={pin.title} /></td>
                                    </tr>
                                    {pin?.price_parameters?.map((parameter, i) => {
                                        return(
                                            <tr>
                                                <td style={{ color: '#ec2d6e' }} key={index}>{parameter.title}</td>
                                                <td key={i}>
                                                    <Autocomplete
                                                        size={"small"}
                                                        onChange={((event, value) => autoCompleteHandleSelect(value, index, 'price_parameters', i))}
                                                        options={parameter.children}
                                                        defaultValue={parameter.selected}
                                                        getOptionLabel={(option) => option.title}
                                                        renderInput={(params) =>
                                                            <TextField
                                                                variant={"outlined"}
                                                                {...params}
                                                                fullWidth
                                                                margin={"dense"}
                                                            />}
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    <tr>
                                        <td><b>قیمت (تومان)</b></td>
                                        <td>
                                            <TextField variant={'outlined'} margin={"dense"} fullWidth={true} size={"small"} onChange={(event) => handleDuplicateRaw(event, index)} name='price'  value={pin.price} />
                                            <CurrencyFormat value={pin.price} displayType={'text'} thousandSeparator={true}  />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><b>تخفیف (درصد)</b></td>
                                        <td>
                                            <TextField variant={'outlined'} margin={"dense"} fullWidth={true} size={"small"} onChange={(event) => handleDuplicateRaw(event, index)} name='discount'  value={pin.discount} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><b>مالیات (تومان)</b></td>
                                        <td>
                                            <TextField variant={'outlined'} margin={"dense"} fullWidth={true} size={"small"} onChange={(event) => handleDuplicateRaw(event, index)} name='tax' value={pin.tax} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><b>تعداد<span>&nbsp;{product && product.package_type && product.package_type.title}&nbsp;</span>کسرکننده از موجودی </b></td>
                                        <td>
                                            <TextField variant={'outlined'} margin={"dense"} fullWidth={true} size={"small"} onChange={(event) => handleDuplicateRaw(event, index)} name='per_count' value={pin.per_count} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><b>حداقل خرید</b></td>
                                        <td>
                                            <TextField variant={'outlined'} margin={"dense"} fullWidth={true} size={"small"} onChange={(event) => handleDuplicateRaw(event, index)} name='minimum_order'  value={pin.minimum_order} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><b>حداکثر خرید</b></td>
                                        <td>
                                            <TextField variant={'outlined'} margin={"dense"} fullWidth={true} size={"small"} onChange={(event) => handleDuplicateRaw(event, index)} name='maximum_order'  value={pin.maximum_order} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><b>پستی (گرم)</b></td>
                                        <td>
                                            <TextField variant={'outlined'} margin={"dense"} fullWidth={true} size={"small"} onChange={(event) => handleDuplicateRaw(event, index)} name='weight'  value={pin.weight} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><b>امتیاز (شبکه)</b></td>
                                        <td>
                                            <TextField variant={'outlined'} margin={"dense"} fullWidth={true} size={"small"} onChange={(event) => handleDuplicateRaw(event, index)} name='point'  value={pin.point} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><b>نقطه سفارش</b></td>
                                        <td>
                                            <TextField variant={'outlined'} margin={"dense"} fullWidth={true} size={"small"} onChange={(event) => handleDuplicateRaw(event, index)} name='order_point'  value={pin.order_point} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><b>وضعیت</b></td>
                                        <td>
                                            <TextField
                                                variant={'outlined'}
                                                margin={"dense"}
                                                fullWidth={true}
                                                size={"small"}
                                                select
                                                value={pin.status}
                                                name='status'
                                                onChange={(event) => handleDuplicateRaw(event, index)}
                                            >
                                                <MenuItem value={1}>فعال</MenuItem>
                                                <MenuItem value={0}>غیرفعال</MenuItem>
                                            </TextField>
                                        </td>
                                    </tr>
                                </table>
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: 'flex-end'}}>
                                    {<Tooltip title={'حذف'}>
                                        <IconButton color='secondary' onClick={() => deleteRaw(index , pin.id)}>
                                            <RemoveCircleIcon />
                                        </IconButton>
                                    </Tooltip>}
                                </div>
                            </fieldset>
                        )
                    })}
                </Paper>
            </Box>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: 'flex-end'}}>
                <Tooltip title={'ایجاد'}>
                    <IconButton color='primary' onClick={() => duplicateRaw(form?.length + 1)}>
                        <Add />
                    </IconButton>
                </Tooltip>
            </div>
            <Box mt={2} className='display-flex display-flex-direction-row display-flex-justify-content-flex-end'>
                <Button disabled={loading} variant='contained' color='primary' type="submit">تکمیل اطلاعات</Button>
            </Box>
            {loading && <Loading/>}
        </form>
    );
})

export default ProductPins;